module.exports = __webpack_public_path__ + "static/media/IconServ.e873be81.svg";